import type { Book } from '../../shared/api';

/** True when every word of `query` appears somewhere in `fields` (empty query matches). */
export function matchesText(fields: ReadonlyArray<string | null | undefined>, query: string): boolean {
  if (!query) return true;
  const haystack = fields.filter(Boolean).join(' ').toLowerCase();
  return query
    .toLowerCase()
    .split(/\s+/)
    .every((term) => haystack.includes(term));
}

/** True when every word of `query` appears in the book's title, subtitle, authors or ISBN. */
export function matchesQuery(book: Book, query: string): boolean {
  return matchesText([book.isbn, book.title, book.subtitle, ...book.authors], query);
}
